import React, { useState, useEffect, Suspense } from 'react'
import axios from 'axios'
import LoadingBar from 'react-top-loading-bar'
import InfiniteScroll from "react-infinite-scroller";
import {Helmet} from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'

import './Images.css'
import styles from '../../App.module.css'
import classes from './Images.module.css'
import ImageBox  from '../Global/ImageBox'
import Spinner from '../Global/Spinner';
import Categories from '../Categories/Categories';

function Images() {
    const [progress, setProgress] = useState(10);
    const [tabIndex, setTabIndex] = useState(0);
    const [type, setType] = useState('mostviewed');
    const [images, setImages] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [page, setPage] = useState(2);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        try{
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }catch(ex){}
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.addEventListener('scroll', function(){
            setLoading(true);
        })
    },[]);

    useEffect(() => {
        if(tabIndex === 0) {
          setType('mostviewed');
          // setType('');
        }else if(tabIndex === 1) {
            setType('latest');
        }else if(tabIndex === 2) {
            setType('mostliked');
        }

        setPage(2);
        setImages([]);
    }, [type, tabIndex]);

    useEffect(() => {
        setProgress(20);
        axios.get(`${process.env.REACT_APP_API_URL}/api/images.php?type=${type}&page=1&limit=8`)
        .then(response => {
            // console.log(response.data);
            setImages(response.data);
            response.data.length < 12 ? sethasMore(false) : sethasMore(true);

            // setLoading(true);
            setProgress(100);
        }).catch(error => {
            console.log(error);
        })
    }, [type])

    const loadMore = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/images.php?type=${type}&page=${page}&limit=8`)
        .then(response => {
            if(response.data.message !== 'No images found') {
                loading && hasMore && setImages([...images, ...response.data]);
                setPage(page + 1);

                response.data.length < 8 ? sethasMore(false) : sethasMore(true);
            }else {
                sethasMore(false);
            }
        }).catch(error => {
            console.log(error);
        })
    }
    
    return (
        <>
            <Helmet>
                <title>Images</title>
            </Helmet>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                    <Sidebar active="images" />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        <ins className='adsbygoogle p-4 pb-0'
                            style={{ display: 'block' }}
                            data-ad-client='ca-pub-8126596259429304'
                            data-ad-slot='5153011292'
                            data-ad-format='auto'
                        />
                        <Categories type="3" />
                        <div className="images-component p-4 mb-5">
                            <div className={classes.sec_heading}>
                                <h2 className='m-0'>Images</h2>
                            </div>
                            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index) }>
                                <TabList>
                                    <Tab>Most views</Tab>
                                    <Tab>Latest</Tab>
                                    <Tab>Most likes</Tab>
                                </TabList>
                                <TabPanel></TabPanel>
                                <TabPanel></TabPanel>
                                <TabPanel></TabPanel>
                            </Tabs>
                            <div className={styles.gallery}>
                                {
                                    <InfiniteScroll
                                        pageStart={0}
                                        loadMore={loadMore}
                                        hasMore={hasMore}
                                        loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                        className='row'
                                    >
                                        {
                                            images && images.map && images.map((image, index) => {
                                                return (
                                                    <div className={`${styles.item} col-lg-3 col-md-4 col-6 col-sm`} key={index}>
                                                        {
                                                            ImageBox(image)
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </InfiniteScroll>
                                }
                            </div>
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Images